import React, { memo, useEffect } from 'react';
import moment from 'moment';
import { get } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { List, ListItem, ListItemText } from '../material-ui/List';
import { Panel } from '../Panel/Panel';
import { FlightTaskItem } from './FlightTaskitem/FlightTaskItem';
import { ErrorBoundary } from '../ErrorBoundary/ErrorBoundary';
import { ProgressIcon } from '../ProgressIcon/ProgressIcon';
import { getDownloadDateInfo } from './FlightTaskitem/tools';
import { getTasksList, setCurrentTask } from '../../actions/tasks';
import { setLoadingState } from '../../actions/progressIndicator';
import { setInitialOfp } from '../../actions/systemOfMeasurement';
import { getFlightTasks } from '../../selectors/screen';
import { useLanguage } from '../hooks/useLanguage/useLanguage';

import './FlightTaskPage.scss';

export const FlightTaskPage = memo(() => {
    const dispatch = useDispatch();
    const flightTasks = useSelector(getFlightTasks);
    const { t: translate } = useTranslation();
    const lastSync = useSelector((state) => getDownloadDateInfo(translate('updated'), get(state, 'tasks.syncTime')));

    const handleLoadTasksList = React.useCallback(() => {
        dispatch(setLoadingState(true));
        dispatch(getTasksList());
    }, []);

    useEffect(() => {
        dispatch(setCurrentTask());
        dispatch(setInitialOfp());
    }, []);

    return (
        <ErrorBoundary>
            <div className="flight-task-list">
                <Panel
                    title={translate('flightTaskPage.flightTaskList')}
                    rightText={<span style={{ padding: '0 16px 0 8px', display: 'block' }}>{lastSync}</span>}
                    icon={<ProgressIcon width="24" height="24" />}
                    onIconClick={handleLoadTasksList}
                >
                    <List>
                        {flightTasks && flightTasks.length > 0 ? (
                            flightTasks.map((item) => {
                                return (
                                    <FlightTaskItem
                                        key={item.id}
                                        id={item.id}
                                        primaryText={`${item.flightTask} (${moment(item.taskDate).format('DD.MM.YYYY')})`}
                                        flights={item.flights}
                                        download={get(item, 'syncTime')}
                                    />
                                );
                            })
                        ) : (
                            <ListItem disabled={true}>
                                <ListItemText primary={translate('flightTaskPage.noFlightTasks')} />
                            </ListItem>
                        )}
                    </List>
                </Panel>
            </div>
        </ErrorBoundary>
    );
});

FlightTaskPage.displayName = 'FlightTaskPage';
